import { CustomerLicenceOptions } from "../stores/authStore";
import { useCustomerLicence } from "./useCustomerLicence";

export const useIsIOM = () =>
  useCustomerLicence() === CustomerLicenceOptions.ISLE_OF_MAN;
